var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_83077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0813 9.77819V9.77706C10.0194 9.78156 9.70051 9.80069 8.98895 9.80069C8.42082 9.80069 8.02088 9.78381 7.88026 9.77706V9.77875C5.69326 9.68256 4.06088 9.30175 4.06088 8.84613C4.06088 8.39106 5.69326 8.01025 7.88026 7.91238V9.39962C8.02313 9.40975 8.43263 9.43394 8.99851 9.43394C9.67744 9.43394 10.0178 9.40581 10.0813 9.40019V7.9135C12.2638 8.01081 13.8923 8.39162 13.8923 8.84613C13.8923 9.30175 12.2638 9.68144 10.0813 9.77819ZM10.0813 7.75881V6.42794H13.1267V4.39844H4.83488V6.42794H7.88026V7.75825C5.40526 7.87188 3.54395 8.36237 3.54395 8.94963C3.54395 9.53687 5.40526 10.0268 7.88026 10.141V14.4059H10.0813V10.1399C12.5524 10.0262 14.4092 9.53631 14.4092 8.94963C14.4092 8.36294 12.5524 7.873 10.0813 7.75881Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_83077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.664bee517405149ef31f9744d2f61e97.svg";
export { ForwardRef as ReactComponent };